const blockProductsSlide = (Swiper, Navigation, Pagination, Autoplay) => {
	let ourProductsSwiper = document.querySelector('.s-our-products__swiper');
	if (ourProductsSwiper) {
		ourProductsSwiper = new Swiper('.s-our-products__swiper', {
			slidesPerView: 1,
			spacebetween: 30,
			observer: true,
			runCallbacksOnInit: true,
			modules: [Navigation, Pagination, Autoplay],
			navigation: {
				nextEl: '.c-swiper-single-arrow--products.c-swiper-single-arrow--next',
				prevEl: '.c-swiper-single-arrow--products.c-swiper-single-arrow--prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				},
				1400: {
					slidesPerView: 3,
				},
			},
		});
	}

	const categoriesSett = (sliderData) => {
		const categories = document.querySelectorAll('.js-cat-product-nav');
		const slides = document.querySelectorAll('.s-our-products__slide');
		const menuMob = document.querySelector('.c-mobile-cat-menu');
		if (categories && slides) {
			categories.forEach((el) => {
				el.addEventListener('click', (e) => {
					const targetId = el.getAttribute('data-termid');
					categories.forEach((cat) => cat.classList.remove('active'));
					e.currentTarget.classList.add('active');

					if (menuMob) document.body.classList.remove('cat-mob');

					slides.forEach((el1) => el1.classList.remove('s-our-products__off'));
					e.preventDefault();

					// checked term
					if (targetId === 'all') {
						slides.forEach((el2) => el2.classList.remove('s-our-products__off'));
					} else {
						slides.forEach((el3) => {
							const cats = el3.dataset.cat;
							if (cats !== targetId) el3.classList.add('s-our-products__off');
						});
					}

					sliderData.updateSize();
					sliderData.updateSlides();
					sliderData.updateProgress();
					sliderData.updateSlidesClasses();
					sliderData.slideTo(0);
				});
			});
		}
	};

	const menuMobileProd = () => {
		const searchBtn = document.querySelector('.c-btn--cat-search');
		if (searchBtn) {
			searchBtn.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.add('cat-mob');
			});
		}
	};

	categoriesSett(ourProductsSwiper);
	menuMobileProd();
};

export default blockProductsSlide;
